// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host ion-grid {
  margin-top: 30px;
}
:host ion-card {
  overflow: visible;
  margin-top: 25px;
}
:host ion-avatar {
  position: absolute;
  margin-top: -30px;
  overflow: visible;
  width: 60px;
  height: 60px;
}
:host ion-item {
  --inner-padding-end: 0px;
}`, "",{"version":3,"sources":["webpack://./src/app/components/custom-animation-list1/custom-animation-list1.component.scss"],"names":[],"mappings":"AACE;EACE,gBAAA;AAAJ;AAGE;EACE,iBAAA;EACA,gBAAA;AADJ;AAIE;EACE,kBAAA;EACA,iBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AAFJ;AAKE;EACE,wBAAA;AAHJ","sourcesContent":[":host {\n  ion-grid {\n    margin-top: 30px;\n  }\n\n  ion-card {\n    overflow: visible;\n    margin-top: 25px;\n  }\n\n  ion-avatar {\n    position: absolute;\n    margin-top: -30px;\n    overflow: visible;\n    width: 60px;\n    height: 60px;\n  }\n\n  ion-item {\n    --inner-padding-end: 0px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
